// slices/serviceSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IService, IServiceState } from "./serviceModel";
import {
  ActiveInactiveService,
  createService,
  deleteService,
  getAllActiveService,
  getAllService,
  getServiceByID,
  updateService,
} from "./services/service.services";

const initialState: IServiceState = {
  loading: false,
  formLoading: false,
  error: "",
  ServiceID: null,
  ServiceList: [],
  ServiceDetail: {
    Title: "",
    IsActive: 1,
  },
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    clearServiceDetails: (state) => {
      state.ServiceDetail = initialState.ServiceDetail;
    },
    setServiceID: (state, action: PayloadAction<number>) => {
      state.ServiceID = action.payload;
    },
    clearServiceID: (state) => {
      state.ServiceID = initialState.ServiceID;
    },
    clearError: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    // Get All Services
    builder.addCase(getAllService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllService.fulfilled,
      (state, action: PayloadAction<IService[]>) => {
        state.loading = false;
        state.ServiceList = action.payload || [];
      },
    );
    builder.addCase(getAllService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ServiceList = [];
    });

    // Create Service
    builder.addCase(createService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Service
    builder.addCase(updateService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Service
    builder.addCase(deleteService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Service By ID
    builder.addCase(getServiceByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getServiceByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ServiceDetail = action.payload;
    });
    builder.addCase(getServiceByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ServiceDetail = initialState.ServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Services
    builder.addCase(getAllActiveService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveService.fulfilled,
      (state, action: PayloadAction<IService[]>) => {
        state.loading = false;
        state.ServiceList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ServiceList = [];
    });

    // Active/Inactive Service
    builder.addCase(ActiveInactiveService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearServiceDetails, clearServiceID, setServiceID, clearError } =
  serviceSlice.actions;

export default serviceSlice.reducer;
